import { call } from 'redux-saga/effects';
import { ICreateAnnualPayload } from './annuals.types';
import * as resourceService from '../../resource/annuals/annuals.saga-service';
import { closeDialog } from '../../dialog/dialog.saga-services';
import { IAnnual } from '../../resource/annuals/annuals.types';
import { addFlashMessage } from '../../../utils/flashMessages.utils';

export function* createAnnual(payload: ICreateAnnualPayload) {
  const result: IAnnual = yield call(resourceService.createAnnual, payload);
  yield call(resourceService.storeAnnuals, result);
  addFlashMessage({
    type: 'success',
    message: 'Annual has been saved!',
  });
  yield call(closeDialog, 'annualAndPeriodsFormDialog');
}

export function* updateAnnual(annualId: IAnnual['id'], payload: ICreateAnnualPayload) {
  const result: IAnnual = yield call(resourceService.updateAnnual, annualId, payload);
  yield call(resourceService.storeAnnuals, result);
  yield call(closeDialog, 'annualAndPeriodsFormDialog');
}

export function* deleteAnnual(annualId: IAnnual['id']) {
  const result = yield call(resourceService.deleteAnnual, annualId);
  if (!result) {
    return;
  }
  yield call(resourceService.clearAnnual, annualId);
  yield call(closeDialog, 'confirmation');
}
